import { newRelicSetAttribute } from '@/utils/newRelic'
import { guid, setCustomDataValuesToEmptyString } from '../utils'
import metadata from './metadata'
import services from './services'

const sendEvent = async (eventType, customFields = {}) => {
  console.log(`%c [Tracr] - ${eventType}`, 'color: #bada55', customFields)

  const tracr = JSON.parse(localStorage.getItem('tracr'))

  if (!tracr) {
    newRelicSetAttribute({
      name: 'tracrError',
      value: '[tracr] Error: tracr is not setup'
    })
    console.error('[tracr] Error: tracr is not setup')
    return
  }

  const { clientId, version, isNewAnonymousId } = tracr
  const eventId = guid()
  const anonymousId = metadata.getAnonymousId()
  const sessionId = metadata.getSessionId()

  const formatedCustomData = setCustomDataValuesToEmptyString(customFields)

  const payload = {
    data: {
      pageName: formatedCustomData.pageName,
      ...customFields
    },
    metadata: {
      clientId,
      eventId,
      eventType,
      version,
      timestamp: new Date().toISOString(),
      identifiers: {
        documentNumber: formatedCustomData.documentNumber,
        email: formatedCustomData.email,
        phoneNumber: formatedCustomData.phoneNumber,
        userId: formatedCustomData.userId,
        anonymousId,
        sessionId,
        userAgent: navigator.userAgent,
        timezoneOffset: new Date().getTimezoneOffset(),
        newAnonymousId: isNewAnonymousId
      },
      webContext: {
        referrer: document.referrer,
        title: document.title,
        url: location.href,
        revisionId: formatedCustomData.revisionId,
        pageType: document.contentType,
        postId: formatedCustomData.postId
      }
    }
  }

  await services.sendEvent(payload)
}

const Events = {
  sendEvent,
  pageview(pageName) {
    sendEvent('PageViewed', { pageName })
  },
  scroll(scrollDistance) {
    sendEvent('PageScrolled', { scrollDistance })
  },
  testAB(data) {
    sendEvent('redtesting.Tracked', data)
  }
}

export default Events
